import myUtils from '../myUtils';
import apiConfig from './apiConfig';

const apiUrl = apiConfig.configApiUrl
const options = (method, body) => apiConfig.configOptions(method, body)
const callApi = (_url, _options) => apiConfig.configCallApi(_url, _options)

//=================== Tag API =============================//

const createEmail = async (body) => {// emailForm.fromEmail, emailForm.toEmailList, emailForm.subject, emailForm.htmlBody
    const url = apiUrl+`/email-forms`;
    const resp = callApi(url, options('POST', body));

    return resp;
}


export default {//Email API
    createEmail,
}